<!-- <div
  (click)="imageClick(0)"
  class="innerBanner"
  [style.background-image]="
    aboutUsDetails.bannerImage
      ? 'url(' + aboutUsDetails.bannerImage + ')'
      : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
  "
> -->

<div (click)="imageClick(0)" class="innerBanner">
  <img
    class="innerBannerImg"
    *ngIf="aboutUsDetails.bannerImage; else noImage"
    [src]="aboutUsDetails.bannerImage"
    alt="Banner Image"
  />

  <ng-template #noImage>
    <img class="innerBanner" src="../../../assets/images/NoImage.jpg" alt="Banner Image" />
  </ng-template>

  <!-- <img
[src]="aboutUsDetails.bannerImage ? aboutUsDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
style="width: 100%"
/> -->
  <div class="bannerText">
    <!-- <h1>{{ aboutUsDetails.bannerTitle }}</h1> -->
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item> <img [src]="item" class="gallery-image" alt="Gallery Image" /> </ng-template>
</p-galleria>

<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <h1>{{ aboutUsDetails.bannerTitle }}</h1>
  <p [innerHTML]="aboutUsDetails.content"></p>
  <!-- <p>&nbsp;</p> -->

  <!-- <nav aria-label="breadcrumb">
<ol class="breadcrumb">
<li class="breadcrumb-item"><a href="/home">Home</a></li>
<li class="breadcrumb-item active" aria-current="page">{{ aboutUsDetails.bannerTitle }}</li>
</ol>
</nav> -->
  <!--
<div class="container contentPanel">
<app-breadcrumb></app-breadcrumb>
<h1>{{ aboutUsDetails.bannerTitle }}</h1>
<p [innerHTML]="aboutUsDetails.content"></p>
<p>&nbsp;</p>
</div>
<div class="container contentPanel">
<div class="highlightSection">
<div class="popular-items">
<p-carousel
[value]="aboutUsDetailsList"
styleClass="custom-carousel"
[numVisible]="4"
[numScroll]="1"
[circular]="true"
class="aboutus-carousel"
[responsiveOptions]="responsiveOptions"
>
<ng-template let-product pTemplate="item">
<div class="product-item slider-arrow">
<a (click)="getDetails(product.title)">
<div class="product-item-content">
<div class="image">
<img src="{{ product.bannerImage }}" class="product-image slider-image" />
</div>
</div>
</a>
</div>
<div class="title">
<h3>{{ product.bannerTitle }}</h3>
</div>
</ng-template>
</p-carousel>
</div>
</div>
</div> -->

  <div class="cetegoriesPanel">
    <div class="noMobile">
      <!-- <h1 translate class="text-center">{{ filteredData[0].name }}</h1> -->
      <div class="">
        <p-tabView class="about-us-tabs">
          <p-tabPanel>
            <ng-template pTemplate="header">
              <!-- <i (click)="getChildItems(childitem)" class="{{ childitem.iconUrl }}"></i> -->
              <!-- <a (click)="getDetails(product.title)"> -->
              <!-- <div> -->
              <div
                *ngFor="let product of aboutUsDetailsList; let imageIndex = index"
                class="aboutUsTabView"
                id="{{ imageIndex }}"
                [style.background-image]="
                  product.bannerImage
                    ? 'url(' + product.bannerImage + ')'
                    : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                "
                (click)="getDetailsOfPage(product.title, imageIndex)"
              >
                <!-- <img src=""  /> -->
                <span>{{ product.bannerTitle }}</span>
              </div>
              <!-- </div> -->
              <!-- </a> -->
            </ng-template>

            <div class="tabContent">
              <h1>{{ aboutUsInfoData.bannerTitle }}</h1>
              <p [innerHTML]="aboutUsInfoData.content"></p>
              <img
                src="{{ aboutUsInfoData.bannerImage }}"
                [attr.alt]="aboutUsInfoData.bannerTitle || 'About us image'"
              />
              <!-- <p>&nbsp;</p> -->
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
    <div class="noDesktop">
      <!-- <div *ngFor="let product of travelInfoDataItems">
<img src="{{ product.bannerImage }}" style="height: 200px;width:200px;" (click)="getTravelInfoDetails(product.bannerTitle)"/>
</div> -->

      <p-accordion class="mb-3">
        <p-accordionTab
          (onOpen)="onTabOpen($event)"
          (onClose)="onTabClose($event)"
          *ngFor="let product of aboutUsDetailsList; let ind = index"
          [selected]="activeState[ind]"
          header="{{ product.bannerTitle }}"
        >
          <div class="tabContent">
            <!-- <h1>{{ product.bannerTitle }}</h1> -->
            <p [innerHTML]="product.content"></p>
            <img src="{{ product.bannerImage }}" [attr.alt]="product.bannerTitle || 'About us image'" />
            <!-- <p>&nbsp;</p> -->
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
